import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';

export const FieldTitle = ({
  title,
  subtitle,
  optional,
  showTooltip,
}: {
  title: string;
  subtitle?: string;
  optional?: boolean;
  showTooltip?: () => void;
}) => {
  return (
    <>
      <h3 className="flex font-bold">
        <Typography variant="subtitle1">{title}</Typography>
        {!optional ? <span className={'text-red-500'}>*</span> : null}
        {showTooltip ? (
          <div className="relative ml-[10px] mt-[4px] cursor-pointer w-[16px] h-[16px]">
            <FontAwesomeIcon
              icon={faCircleQuestion as any}
              className="absolute left-0 top-0 ml-0 text-blue-600"
              onClick={showTooltip}
            />
          </div>
        ) : null}
      </h3>
      {subtitle ? (
        <Typography variant="subtitle2" gutterBottom>
          {subtitle}
        </Typography>
      ) : null}
    </>
  );
};
